import { useQuery, UseQueryOptions } from 'react-query';

import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

import useNotify from './useNotify';

const QUERY_KEY_PREFIX = 'query-admins';
const getQueryKey = (integrationId: string) =>
  `${QUERY_KEY_PREFIX}-${integrationId}`;

function useQueryAdmins(
  integrationId: string,
  options?: UseQueryOptions<{ objects: any }>
) {
  const notify = useNotify();

  const queryKey = getQueryKey(integrationId);
  const url = `${ZAPIER_APP_BASE_URL}/api/platform/cli/apps/${integrationId}/collaborators`;

  const { data, error, ...rest } = useQuery(
    queryKey,
    () => fetch(url, { credentials: 'include' }).then(res => res.json()),
    options
  );

  if (error) {
    notify.failure('Failed to fetch admins.');
  }

  const admins = data?.objects ?? [];

  return { ...rest, admins, error, queryKey };
}

export default useQueryAdmins;
export { getQueryKey, QUERY_KEY_PREFIX };
